import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'

import { environment } from '../../../environments/environment'

@Injectable({
  providedIn: 'root',
})
export class FeedbackService {
  private baseUrl = environment.baseUrl

  constructor(private http: HttpClient) {}

  submitFeedback(formData: FormData): Observable<any> {
    return this.http.post(`${this.baseUrl}/feedback/submit`, formData)
  }
}

